import React from "react"
import PropTypes from "prop-types"
import { FormGroup, Input, Label } from "reactstrap"
import {
  ACTIVIDADES,
  ETIQUETAS_NIVEL,
  bloqueadasDe,
  bloqueadoPor,
  efectivaDe,
  textoResumenPrevio,
} from "./nivelesImportacion"

export const ID_SELECTOR_NIVELES = "selector-niveles"

const idCheck = nivel => `chk-nivel-${nivel}`
const idNota = nivel => `nota-nivel-${nivel}`

const DESCRIPCION_NIVEL = Object.freeze({
  productores:
    "Borra y vuelve a importar los productores migrados y todo lo que depende de ellos. Incluye Establecimientos y las tres actividades.",
  establecimientos:
    "Borra y vuelve a importar los establecimientos migrados. Incluye Siembras, Ganadería y Tambo. No toca los productores ni ARCA.",
  siembras: "Solo las siembras migradas.",
  ganaderia: "Solo el stock ganadero migrado.",
  tambo: "Solo los tambos migrados.",
})

// Casilla de un nivel: bloqueada (marcada, sin respuesta al clic) si la implica
// un ancestro marcado.
const CasillaNivel = ({ nivel, marcadas, efectiva, bloqueada, onAlternar }) => {
  const raiz = bloqueada ? bloqueadoPor(marcadas, nivel) : null
  const motivo = raiz
    ? `Incluido por ${ETIQUETAS_NIVEL[raiz]}: se borra y se vuelve a importar junto con él.`
    : undefined
  return (
    <FormGroup
      check
      className="mb-2"
      data-testid={`nivel-${nivel}`}
      title={motivo}
    >
      <Input
        type="checkbox"
        id={idCheck(nivel)}
        checked={efectiva.includes(nivel)}
        disabled={bloqueada}
        aria-describedby={idNota(nivel)}
        data-bloqueada={bloqueada ? "true" : "false"}
        onChange={() => onAlternar(nivel)}
      />
      <Label check for={idCheck(nivel)} className="fw-semibold">
        {ETIQUETAS_NIVEL[nivel]}
      </Label>
      <small id={idNota(nivel)} className="text-muted d-block">
        {DESCRIPCION_NIVEL[nivel]}
        {raiz && (
          <span
            className="ms-1 fst-italic"
            data-testid={`nivel-${nivel}-bloqueo`}
          >
            (Incluido por {ETIQUETAS_NIVEL[raiz]}.)
          </span>
        )}
      </small>
    </FormGroup>
  )
}

/**
 * Selector jerárquico de niveles de la Importación Masiva:
 * [Productores] ⊃ [Establecimientos] ⊃ [Siembras] [Ganadería] [Tambo].
 * Presentacional: el estado (marcas EXPLÍCITAS) lo maneja quien lo usa.
 */
const SelectorNiveles = ({ marcadas, onAlternar, excluirArca }) => {
  const efectiva = efectivaDe(marcadas)
  const bloqueadas = bloqueadasDe(marcadas)
  const props = nivel => ({
    nivel,
    marcadas,
    efectiva,
    bloqueada: bloqueadas.includes(nivel),
    onAlternar,
  })
  return (
    <fieldset
      id={ID_SELECTOR_NIVELES}
      data-testid={ID_SELECTOR_NIVELES}
      className="border rounded p-3 mb-3"
    >
      <legend className="float-none w-auto fs-6 px-2 mb-0">Qué importar</legend>
      <CasillaNivel {...props("productores")} />
      <div className="ms-4 border-start ps-3">
        <CasillaNivel {...props("establecimientos")} />
        <div className="ms-4 border-start ps-3">
          {ACTIVIDADES.map(a => (
            <CasillaNivel key={a} {...props(a)} />
          ))}
        </div>
      </div>
      <div
        className={`alert ${efectiva.length ? "alert-info" : "alert-warning"} mb-0 mt-2 py-2`}
        data-testid="resumen-previo"
        role="status"
      >
        <i className="mdi mdi-information-outline me-2" aria-hidden="true" />
        {textoResumenPrevio(efectiva, { excluirArca })}
      </div>
    </fieldset>
  )
}

CasillaNivel.propTypes = {
  nivel: PropTypes.string.isRequired,
  marcadas: PropTypes.array.isRequired,
  efectiva: PropTypes.array.isRequired,
  bloqueada: PropTypes.bool,
  onAlternar: PropTypes.func.isRequired,
}
SelectorNiveles.propTypes = {
  marcadas: PropTypes.array.isRequired,
  onAlternar: PropTypes.func.isRequired,
  excluirArca: PropTypes.bool,
}

export default SelectorNiveles
